// Filename: Header.js
import React from "react";
import { useState, useEffect } from "react";
import styled from "styled-components";
import quranWebp from "../images/Quran.webp";
import backgroundImage from "../images/white.jpg";
import { useNavigate } from "react-router-dom";
import Phone from "./PhoneFinal.js";
import Winner from "./WinnerFinal.js";
const HeaderWrapper = styled.header`
  /*background-image: url(${backgroundImage});*/
  background-color: #f5f5f5;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding: 20px;
`;

const HeroSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px 20px;

  @media (min-width: 900px) {
    flex-direction: row;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
`;

const HeroText = styled.div`
  flex: 1;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center; /* Default: center on mobile */
  text-align: center;

  @media (min-width: 768px) {
    align-items: flex-start;
    text-align: left;
  }
`;


const HeroImage = styled.img`
  width: 80%;
  max-width: 400px;
  height: auto;
  margin: 20px 0;

  @media (min-width: 500px) {
    width: auto;
    max-width: 100%;
    margin-left: 40px;
  }
`;

const Header = () => {
  const post = ()=>{
    fetch('', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  body: new URLSearchParams({
    'entry.1389569988': 'John Doe',
    'entry.632217326': 'john@example.com',
    'entry.71977802': '123 Street Name'
    // add the rest...
  })
});
  post();
  }
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/Info"); // Navigate to the About page
  };
  /*
  const containerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    background: "#f0f0f0",
    padding: "20px",
  };

  const phoneFrameStyle = {
    position: "relative",
    width: "90vw", // Responsive width
    maxWidth: "800px", // Max width for large screens
    aspectRatio: "16 / 9", // Keeps video ratio
    border: "1.8vw solid #333",
    borderRadius: "6vw",
    backgroundColor: "#000",
    boxShadow: "0 0 20px rgba(0, 0, 0, 0.5)",
    overflow: "hidden",
    justifySelf: "center",
    margin: "20px auto",
    /* 
    position: "relative",
    width: "500px",
    height: "295px",
    border: "16px solid #333",
    borderRadius: "40px",
    backgroundColor: "#000",
    boxShadow: "0 0 20px rgba(0, 0, 0, 0.5)",
    margin: "20px auto",
    overflow: "hidden",
    */
  /*};

  const iframeStyle = {
    width: "100%",
    height: "100%",
    padding: 5,
    border: "none",
  };*/
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreen = () => setIsMobile(window.innerWidth < 768);
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  const [isHovered, setIsHovered] = useState(false);

  const buttonStyle = {
    backgroundColor: isHovered ? "#3c3866" : "#007BFF",
    color: "#ffffff",
    borderRadius: "20px",
    padding: "20px 30px",
    fontSize: 20,
    marginTop: 20,
    textDecoration: "underline",
    cursor: "pointer"
  };
  return (
    <HeaderWrapper style={{ marginTop: "-50px" }}>
      <Phone />
      <div style={{ margin: -20, backgroundColor: "#FF3C8A" }}>
        <HeroSection style={{ alignItems: "center" }}>  
        <HeroText>
          <h1
            style={{
              color: "#ffffff",
              fontSize: "clamp(2rem, 5vw, 3rem)",
              lineHeight: 1.2,
              margin: 0,
              textAlign: isMobile ? "center" : "left",
            }}
          >
            <span style={{ display: "block" }}>Recite Quran</span>
            <span style={{ display: "block" }}>on TV & win</span>
            <span style={{ display: "block" }}>Great Prizes</span>
          </h1>

          <p style={{ color: "#ffffff", marginTop: 20 }}>
            Get your parent's permission! Mom and Dad can help you!!
          </p>

          <button
            style={buttonStyle}
            onClick={handleClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            Register Now!
          </button>
        </HeroText>
        
        <HeroImage
          /*src="https://via.placeholder.com/400x300"*/
          fetchpriority="high"
          src={quranWebp}
          type="image/webp"
          style={{ width: 500 }}
          alt="Quran Recitation"
        />
      </HeroSection>
      
      </div>
      <Winner/>
    </HeaderWrapper>
  );
};

export default Header;
